import React, { useState } from "react";
import { Button } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { AdSystemT, useOrganizationMonthlyBudgetQuery } from "../../graphql/generated/graphql";
import { formatCurrencyUnit } from "../../i18n/formatNumbers";
import NumberFieldWithUnit from "../NumberFieldWithUnit";
import { SmallLoader } from "../SmallLoader";
import { MonthlyBudget } from ".";

type MonthlyBudgetPropsT = {
  adSystem?: AdSystemT;
};

export const UpdateMonthlyBudget = ({ adSystem = AdSystemT.GoogleAdsT }: MonthlyBudgetPropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.MonthlyBudget" });
  const { data: dataMonthlyBudget, loading: loadingBudget } = useOrganizationMonthlyBudgetQuery();
  const [edditing, setEditting] = useState(false);

  // Get monthly budget based on ad system
  const adSettingBudget =
    adSystem === AdSystemT.GoogleAdsT
      ? dataMonthlyBudget?.organization?.googleAdsSetting?.monthlyBudget
      : dataMonthlyBudget?.organization?.metaAdsSetting?.monthlyBudget;

  if (loadingBudget) {
    return (
      <div>
        <SmallLoader />
      </div>
    );
  }
  return edditing ? (
    <MonthlyBudget adSystem={adSystem} afterEditButton onComplete={() => setEditting(false)} />
  ) : (
    <div
      className="monthly-budget-wrapper"
      style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "24px 0" }}
    >
      <NumberFieldWithUnit
        label={t("Label")}
        name="current_monthly_budget"
        unit={formatCurrencyUnit(adSettingBudget?.currency || "CZK")}
        value={adSettingBudget?.amount || 0}
        addon={
          <div className="edit-btn-addon" style={{ marginRight: "10px" }}>
            <Button data-test-id="update-monthly-budget-button" onClick={() => setEditting(true)}>
              {t("Edit button")}
            </Button>
          </div>
        }
        disabled
      />
    </div>
  );
};
